import React from 'react';
import { Card, ProgressBar } from 'react-bootstrap';
import { getProgressPercent } from '../utils/batchProgress';

function OperationProgress({
  title,
  processed = 0,
  total = 0,
  success = 0,
  failed = 0,
  variant = 'primary',
  asCard = true,
  className = 'mb-3',
  showCounts = true,
}) {
  const percent = getProgressPercent({ processed, total });

  const content = (
    <>
      {title && <h6 className="mb-3">{title}</h6>}
      <ProgressBar
        now={percent}
        animated
        striped
        variant={variant}
        label={total > 0 ? `${percent}%` : undefined}
        className="mb-2"
      />
      {showCounts && (
        <div className="d-flex justify-content-between small text-muted">
          <span>
            {processed.toLocaleString()}
            {total > 0 ? ` / ${total.toLocaleString()}` : ''}
            {total > 0 ? ' items' : ' processed'}
          </span>
          {(success > 0 || failed > 0) && (
            <span>
              {success.toLocaleString()} ok
              {failed > 0 ? `, ${failed.toLocaleString()} failed` : ''}
            </span>
          )}
        </div>
      )}
    </>
  );

  if (asCard) {
    return (
      <Card className={className}>
        <Card.Body>{content}</Card.Body>
      </Card>
    );
  }

  return <div className={className}>{content}</div>;
}

export default OperationProgress;
